var React = require('react');

function JsLogoInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 1L15 15.5L9 17.5L3 15.5L1 1H17Z","stroke":"#236F9A","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M4.5 5H7.5V13L5.5 12M13.5 5H11C10.8674 5 10.7402 5.05268 10.6464 5.14645C10.5527 5.24021 10.5 5.36739 10.5 5.5V8.5C10.5 8.63261 10.5527 8.75979 10.6464 8.85355C10.7402 8.94732 10.8674 9 11 9H12.423C12.4946 9.00001 12.5653 9.01539 12.6304 9.04509C12.6955 9.07479 12.7535 9.11812 12.8004 9.17216C12.8474 9.22619 12.8821 9.28968 12.9024 9.35831C12.9227 9.42695 12.928 9.49914 12.918 9.57L12.5 12.5L10.5 13","stroke":"#236F9A","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

JsLogoInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = JsLogoInline;

JsLogoInline.default = JsLogoInline;
